document.addEventListener('DOMContentLoaded', async () => { 
    const updateMetafield = async (customerId, collectionId) => {
        const response = await fetch('https://api.seoulbeautyclub.com/api/customer-update-collection', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                boxCollection: collectionId,
                customerId: customerId
            })
        });

        if (response.ok) {
            console.log('Metafield updated successfully');
        } else {
            console.error('Error updating metafield');
        }
    }

    const boxPicker = document.querySelector('.box-inside');
    let customerId = boxPicker.dataset.customerId;
    let currentCollectionId = boxPicker.dataset.currentCollectionId;
    let collectionId = boxPicker.dataset.collectionId;
    let boxPickerButton = document.querySelector('.box-inside__pick');
    
    if (collectionId === currentCollectionId) {
        boxPickerButton.click();
    }

    boxPickerButton.addEventListener('click', async () => {
        boxPickerButton.querySelector('.box-inside__radio').click();
        await updateMetafield(customerId, collectionId);
    });
});